module.exports = __webpack_public_path__ + "img/STAR SHADES RED.2ab076d.svg";